import moment from 'moment';
import fields from './fields.utils.js';

const schema_fleet = {
    ...fields.notes,
    //source
    'source_uuid': {
        type: 'select',
        label: 'source',
        value: '',
        options: [],
        required: true,
    },
    // proposer
    ...fields.title,
    'first_name': {
        label: 'First Name',
        placeholder: 'First Name',
        type: 'text',
        value: '',
        required: true,
    },
    'last_name': {
        label: 'Last Name',
        placeholder: 'Last Name',
        type: 'text',
        value: '',
        required: true,
    },
    'email': {
        label: 'Email Address',
        placeholder: 'Email Address',
        type: 'email',
        value: '',
    },
    'telephone': {
        label: 'Telephone',
        placeholder: 'Telephone',
        type: 'text',
        value: '',
        required: true,
    },
    //company
    'company_name': {
        type: 'text',
        label: 'Company name',
        value: '',
        options: [],
        required: true
    },
    'company_year': {
        label: 'Company establishment date (Year)',
        type: 'date-mask',
        mask: '9999',
        value: moment().format('YYYY'),
        required: true,
        placeholder: 'Company established',
    },
    'address1': {
        label: 'Company Address Line 1',
        placeholder: 'Address Line 1',
        value: '',
        type: 'text',
        required: true,
    },
    'address2': {
        label: 'Company Address Line 2',
        placeholder: 'Address Line 2',
        value: '',
        type: 'text',

    },
    'address3': {
        label: 'Company Address Line 3',
        placeholder: 'Address Line 3',
        type: 'text',
        value: '',

    },
    'address4': {
        label: 'Company Address Line 4',
        placeholder: 'Address Line 4',
        type: 'text',
        value: '',
    },
    'city': {
        label: 'Company City',
        placeholder: 'City',
        type: 'text',
        value: '',
        required: true,
    },
    'postcode': {
        label: 'Company Postal Code',
        placeholder: 'Postal Code',
        type: 'address-lookup',
        value: '',
        required: true,
    },
    'company_business': {
        label: 'Company Business',
        type: 'auto-suggest',
        required: true,
        options: [],
    },
    //vehicle
    'number_of_vehicles': {
        label: 'number of vehicles',
        type: 'number',
        value: 3,
        required: true,
        placeholder: 'number of vehicles',
    },
    'private_hire': {
        label: 'Private hire',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'public_hire': {
        label: 'Public hire',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'haulage_use': {
        label: 'Haulage use',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'vans': {
        label: 'Vans',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'cars': {
        label: 'Cars',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'motorbikes': {
        label: 'Motorbikes',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'pickups': {
        label: 'Pickups',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'trucks': {
        label: 'Trucks',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'taxis': {
        label: 'Taxis',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'minibuses': {
        label: 'Minibuses',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'other': {
        label: 'Other',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'driving_restrictions': {
        label: 'Driving Restrictions',
        type: 'select',
        value: '',
        options: [],
        placeholder: 'Driving Restrictions',
        required: true
    },
    'claims_experience': {
        label: 'claims experience',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    //policy
    'cover_date': {
        label: 'Cover Date',
        type: 'date-picker',
        value: moment().format('DD/MM/YYYY'),
        required: true,

        placeholder: 'Cover Date',
    },
    //marketing
    ...fields.marketing,
    ...fields.cross_selling
};
export default schema_fleet;
